import {UserClient} from '../../../api/api';
import {AsyncOperationBuilder} from '../../../utilities/api-helper';
import {userClient} from '../api-clients';
import {getUsersAction} from './actions';

export async function getUsers() {
  return AsyncOperationBuilder(
    getUsersAction,
    (apiClient) => (apiClient as UserClient).getUsers(),
    undefined,
    userClient,
  );
}
